'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  init: function init() {
    var utmCookieKey = '__md_utm_campaign_url=';
    var queryString = window.location.search;

    var updateGfUtm = function updateGfUtm() {
      var gravityForms = document.querySelectorAll('.gform_wrapper');

      if (gravityForms) {
        if (document.cookie.split(';').some(function (item) {
          return item.trim().indexOf(utmCookieKey) === 0;
        })) {
          var cookieValue = document.cookie.split('; ')
          // .find(row => row.startsWith(utmCookieKey))
          .find(function (row) {
            return row.startsWith(utmCookieKey);
          }).split('=')[1];

          if (cookieValue && cookieValue !== 'undefined') {
            var url = new URL(decodeURIComponent(cookieValue));
            var searchQuery = url.search;

            if (searchQuery) {
              var urlParams = new URLSearchParams(searchQuery);
              var variableList = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

              gravityForms.forEach(function (gform) {
                var form = gform.querySelector('form');
                var fields = form.querySelectorAll('.gfield_visibility_hidden');

                if (fields && fields.length > 0) {
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var field = _step.value;

                      var label = field.querySelector('label');
                      var input = field.querySelector('input');
                      var labelText = label.innerHTML;
                      var urlParam = urlParams.get(labelText);

                      if (variableList.includes(labelText) && urlParam) {
                        input.value = urlParam;
                      }
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                }
              });
            }
          }
        }
      }
    };

    if (queryString) {
      var qsParams = new URLSearchParams(queryString);

      // console.log(qsParams);
      if (qsParams.get('utm_campaign') || qsParams.get('utm_content') || qsParams.get('utm_source') || qsParams.get('utm_term') || qsParams.get('utm_medium') || qsParams.get('gclid')) {
        document.cookie = utmCookieKey + encodeURIComponent(window.location.href) + ';path=/;';
        // console.log(utmCookieKey + encodeURIComponent(window.location.href));
        updateGfUtm();
      }
    } else {
      updateGfUtm();
    }
  }
};


// WEBPACK FOOTER //
// ./scripts/components/utm.js